module.exports = __webpack_public_path__ + "static/media/exercises-step13.dec8d5a4.png";